import { render, staticRenderFns } from "./VideoCallDSTBPheDuyet.vue?vue&type=template&id=34e1be3e&scoped=true"
import script from "./VideoCallDSTBPheDuyet.vue?vue&type=script&lang=js"
export * from "./VideoCallDSTBPheDuyet.vue?vue&type=script&lang=js"
import style0 from "./VideoCallDSTBPheDuyet.vue?vue&type=style&index=0&id=34e1be3e&prod&lang=scss"
import style1 from "./VideoCallDSTBPheDuyet.vue?vue&type=style&index=1&id=34e1be3e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34e1be3e",
  null
  
)

export default component.exports